"use client";

import { cx } from "styled-system/css";

type GradientVariant = "gray" | "gold";

interface GradientTextProps {
  children: React.ReactNode;
  className?: string;
  variant?: GradientVariant;
}

export function GradientText({ children, className, variant = "gray" }: GradientTextProps) {
  const gradientClass = variant === "gold" ? "gradient-text-gold" : "gradient-text";

  return (
    <>
      <style>{`
        .gradient-text {
          background: linear-gradient(180deg, #f8f8f8 18.75%, #6d6863 93.75%);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          -webkit-text-fill-color: transparent;
        }
        .gradient-text-gold {
          background: linear-gradient(180deg, #f8cc4a 18.75%, #4d3f17 93.75%);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          -webkit-text-fill-color: transparent;
        }
        @supports (color: color(display-p3 0 0 0)) {
          .gradient-text {
            background: linear-gradient(180deg, color(display-p3 0.973 0.973 0.973) 18.75%, color(display-p3 0.427 0.408 0.388) 93.75%);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      `}</style>
      <span className={cx(gradientClass, className)}>{children}</span>
    </>
  );
}
